
export default {
  name: 'contacts',
  components: {},
  props: ['respData'],
  data () {
    return {
      responseData:{},
      headers_Contacts:[
        {text:"Type", value:"type"},
        {text:"Name", value:"name"},
        {text:"Company Name", value:"companyName"},
      ],
    }
  },
  computed: {

  },
  mounted () {
    this.responseData = this.respData;
    console.log(this.responseData);
  },
  methods: {

  }
}


